import { FormControl, MenuItem } from '@mui/material';
import { FC } from 'react';
import { SMBSelect } from '../input';

interface IClosingDateLockedDropdownProps {
  value: boolean | undefined;
  handleChange: (val: boolean | undefined) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  inputLabel?: string;
  name?: string;
}

export const ClosingDateLockedDropdown: FC<IClosingDateLockedDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  name
}) => {
  const options = [
    { value: undefined, label: 'All' },
    { value: true, label: 'Closing Date Locked' },
    { value: false, label: 'Closing Date Not Locked' }
  ];

  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired}>
      <SMBSelect
        name={name || null}
        disabled={isDisabled}
        label={inputLabel ?? 'Closing Date Status'}
        value={value === undefined ? '' : value.toString()}
        required={isRequired}
        onChange={({ target: { value } }) => {
          if (value === 'true') {
            handleChange(true);
          } else if (value === 'false') {
            handleChange(false);
          } else {
            handleChange(undefined);
          }
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
        handleClear={() => handleChange(undefined)}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value === undefined ? '' : option.value.toString()}>
            {option.label}
          </MenuItem>
        ))}
      </SMBSelect>
    </FormControl>
  );
};